import { render } from "./ProjectOverviewWidget.vue?vue&type=template&id=0be927da&scoped=true"
import script from "./ProjectOverviewWidget.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewWidget.vue?vue&type=script&lang=js"

import "./ProjectOverviewWidget.vue?vue&type=style&index=0&id=0be927da&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be927da"]])

export default __exports__